<form [formGroup]="dateForm" *ngIf="type == 'datepicker'">
  <mat-form-field class="date-picker">
    <input matInput [matDatepicker]="picker" [placeholder]="dateFormat" appDateInputMask formControlName="date" (input)="onInputDateChange($event)" (blur)="checkDateValue($event)"
      #input>
    <mat-datepicker-toggle matIconSuffix [for]="picker" class="adc-mt2"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
    <mat-error *ngIf="dateForm.get('date')?.hasError('required')">
      Date is required.
    </mat-error>
    <mat-error *ngIf="dateForm.get('date')?.hasError('monthInvalid')">
        Please enter a valid month.
    </mat-error>
    <mat-error *ngIf="dateForm.get('date')?.hasError('dayInvalid')">
        Please enter a valid day.
    </mat-error>
    <mat-error *ngIf="dateForm.get('date')?.hasError('yearInvalid')">
        Please enter a valid year.
    </mat-error>
    <mat-error *ngIf="dateForm.get('date')?.hasError('leapYearInvalid')">
        February has only 28 days in the selected year (29 in leap years).
    </mat-error>
    <mat-error *ngIf="dateForm.get('date')?.hasError('dateInvalid')">
        Please enter a valid date in the specified format.
    </mat-error>
  </mat-form-field>
  <mat-form-field class="adc-ml16 time-picker" *ngIf="timePicker">
    <input matInput [ngxMatTimepicker]="timepicker" placeholder="HH:MM a" formControlName="time"
    >
    <div class="icon adc-mr5" (click)="openTimePicker()">
      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="20px" fill="#757575">
        <path d="m608.41-290.57 61.5-61.02-146.32-146.32V-678.8h-87.18v216.13l172 172.1ZM480-71.87q-84.91 0-159.34-32.12-74.44-32.12-129.5-87.17-55.05-55.06-87.17-129.5Q71.87-395.09 71.87-480t32.12-159.34q32.12-74.44 87.17-129.5 55.06-55.05 129.5-87.17 74.43-32.12 159.34-32.12t159.34 32.12q74.44 32.12 129.5 87.17 55.05 55.06 87.17 129.5 32.12 74.43 32.12 159.34t-32.12 159.34q-32.12 74.44-87.17 129.5-55.06 55.05-129.5 87.17Q564.91-71.87 480-71.87ZM480-480Zm0 317.13q131.8 0 224.47-92.54 92.66-92.55 92.66-224.59 0-132.04-92.66-224.59-92.66-92.54-224.47-92.54-131.8 0-224.47 92.54-92.66 92.55-92.66 224.59 0 132.04 92.66 224.59 92.66 92.54 224.47 92.54Z"/>
      </svg>
    </div>
    <ngx-mat-timepicker
    #timepicker
    [enableKeyboardInput]="true"
    (closed)="onTimeChange(dateForm.get('time')?.value)"
    ></ngx-mat-timepicker>
    <mat-error *ngIf="dateForm.get('time')?.hasError('required')">
      Please select a time
    </mat-error>
  </mat-form-field>

</form>

<form *ngIf="type == 'inline-datepicker'">
  <mat-calendar (selectedChange)="getDate($event)"></mat-calendar>
</form>

<!-- <p>Formatted Date: {{ getFormattedDate() }}</p> -->

<form [formGroup]="dateRangeForm" *ngIf="type == 'daterangepicker'">
<mat-form-field class="">
  <mat-date-range-input [rangePicker]="picker2">
  <input matStartDate placeholder="MM/DD/YYYY" formControlName="startDate" appDateInputMask [(ngModel)]="startDate" (focus)="onFocus('start')">
  <input matEndDate placeholder="MM/DD/YYYY" formControlName="endDate" appDateInputMask [(ngModel)]="endDate" (focus)="onFocus('end')">
  </mat-date-range-input>
  <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
  <mat-date-range-picker #picker2></mat-date-range-picker>
  <mat-error *ngIf="dateRangeForm.get('startDate')?.hasError('matDatepickerParse') || dateRangeForm.get('endDate')?.hasError('matDatepickerParse') ">
  Not a valid date
  </mat-error>
  <mat-error *ngIf="dateRangeForm.get('startDate')?.hasError('required')">
  Please select start date
  </mat-error>
  <mat-error *ngIf="dateRangeForm.get('endDate')?.hasError('required') && !dateRangeForm.get('startDate')?.hasError('required')">
  Please select end date
  </mat-error>

</mat-form-field>
</form>